import { useTranslation } from "react-i18next";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import ArticleGridCard from "@/components/feature/ArticleGridCard";
import { useLocalization } from "@/hooks/useLocalization";
import { articlesByLang } from "@/data/articles";
import Hero from "./components/Hero";
import CategoryBrowse from "./components/CategoryBrowse";
import ShoppingCompanion from "./components/ShoppingCompanion";
import WhyChooseUs from "./components/WhyChooseUs";
import FaqSection from "./components/FaqSection";
import CtaFooter from "./components/CtaFooter";
import SpreadsheetPreview from "./components/SpreadsheetPreview";

export default function Home() {
  const { lang, t } = useLocalization();
  const articles = articlesByLang[lang];

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Navbar />

      <main className="flex-1">
        <Hero />

        <CategoryBrowse />

        <ShoppingCompanion />

        <SpreadsheetPreview lang={lang} />

        <WhyChooseUs />

        {/* Articles grid */}
        <section id="guides" className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
            <div className="text-center">
              <span className="text-xs font-semibold tracking-wider uppercase text-primary-600">
                {t("articles.badge")}
              </span>
              <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
                {t("articles.title")}
              </h2>
              <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
                {t("articles.subtitle")}
              </p>
            </div>

            <div className="mx-auto mt-10 grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-2">
              {articles.map((article) => (
                <ArticleGridCard key={article.slug} article={article} lang={lang} />
              ))}
            </div>

          </div>
        </section>

        <FaqSection />

        <CtaFooter />
      </main>

      <Footer />
    </div>
  );
}